var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckIcon = function SvgCheckIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5391 4.37515L10.5391 4.37515C10.7246 4.18965 11.0253 4.18964 11.2108 4.37515C11.3963 4.56065 11.3963 4.86141 11.2108 5.04691M10.5391 4.37515L11.1401 4.97619M10.5391 4.37515L6.11705 8.79721M10.5391 4.37515L4.46083 7.14099M11.2108 5.04691L11.1401 4.97619M11.2108 5.04691L11.2108 5.0469L11.1401 4.97619M11.2108 5.04691L6.45292 9.8048C6.26756 9.99016 5.96663 9.99032 5.78116 9.80479M11.1401 4.97619L6.38221 9.73409C6.23587 9.88042 5.99828 9.88053 5.85188 9.73409M5.78116 9.80479L5.78117 9.8048L5.85188 9.73409M5.78116 9.80479L3.78907 7.81273L3.85978 7.74202M5.78116 9.80479L5.85188 9.73409M5.85188 9.73409L3.85978 7.74202M3.85978 7.74202C3.71333 7.59556 3.71333 7.35814 3.85978 7.2117C4.00625 7.06526 4.24368 7.06525 4.39012 7.2117M3.85978 7.74202L6.18776 8.86792L6.11705 8.79721M3.85978 7.74202L3.78907 7.81273C3.60357 7.62722 3.60356 7.32648 3.78908 7.14099L3.78908 7.14098C3.97459 6.95551 4.27532 6.95547 4.46083 7.14099M3.85978 7.74202L4.46083 7.14099M4.39012 7.2117L6.04634 8.86792L6.11705 8.79721M4.39012 7.2117L4.46083 7.14099M4.39012 7.2117L4.46083 7.14099M6.11705 8.79721L4.46083 7.14099M4.46083 7.14099L4.46083 7.14099",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-icon.f9be2062.svg";
export { ForwardRef as ReactComponent };